
import { useState, useEffect } from 'react';

const devices = {
  mobile: "(max-width: 768px)",
  tablet: "(min-width: 769px) and (max-width: 1024px)",
  desktop: "(min-width: 1025px)",
};

const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState({
        isMobile: false,
        isTablet: false,
        isDesktop: true, // Default to desktop for SSR/initial render
        device: "desktop"
    });

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.matchMedia(devices.mobile).matches;
            const isTablet = window.matchMedia(devices.tablet).matches;
            const isDesktop = window.matchMedia(devices.desktop).matches;

            let device = "desktop";
            if (isMobile) device = "mobile";
            else if (isTablet) device = "tablet";

            setDeviceType({ isMobile, isTablet, isDesktop, device });
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return deviceType;
};

export default useDeviceType;
